import React,  {useEffect} from 'react';
import PropTypes from "prop-types";
import MetaTags from 'react-meta-tags';
import { Col, Container, Row } from "reactstrap"

import {withRouter, useParams} from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Loader from "../../components/Common/Loader";
import SweetAlert from "react-bootstrap-sweetalert"
//Import Components
import LeftSidebarProfile from './components/LeftSidebarProfile';
import ProfileTab from './components/ProfileTab';

//redux
import {connect, useDispatch} from "react-redux";

import {contactsList} from "../../store/contacts/actions"
import { contactsFulllist } from "../../store/contacts/actions";
import { casosFilter } from '../../store/casos/actions';



const ContactProfile = props => {
    
    const dispatch = useDispatch();
    const param = useParams();
    const str = param.id; 
    const contactoId = Number(str);


    useEffect(() => {
        
     dispatch(contactsList());
     dispatch(contactsFulllist())
     dispatch(casosFilter(`get_caso_contacto/?contacto=${contactoId}`))
              
    },[dispatch, contactoId]);
    
      const params = {
        count: props.contacts.count,
        results: props.contacts.results,
      };
    
      const contacto = Array.isArray(params.results) ? params.results.filter(item => item.id === contactoId) :[];


      const handleReload = () => {
        window.location.reload();
      };
     
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>tccontrol| Perfil del Contacto</title>
                </MetaTags>


                {props.contactsUpdated.id  ? (
                  <SweetAlert
                    title="Hecho!"
                    success  
                    timeout={1000}                
                    showConfirm={false}
                    onConfirm={() =>{
                      handleReload()
                    }}
                    
                  >
                    Se ha editado el usuario con éxito 
                  </SweetAlert>
                ) : null}


                {props.error  ? (
                  <SweetAlert
                    title="Error"
                    success ={false}
                    timeout={2000}                
                    showConfirm={false}
                    onConfirm={() =>{
                        handleReload()
                    }}
                    
                  >
                    Ha habido un error con el  en {props.error.tipo_cliente ? `${props.error.tipo_cliente} en tipo cliente`:null} 
                  </SweetAlert>
                ) : null}


                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs title="tccontrol" breadcrumbItem="Perfil del Contacto" />
                    {props.loading ? (
                    <Loader />
          ) : (

                    <Row className="mb-4">
                        <Col>
                            
                            <LeftSidebarProfile contactos = {contacto} />
                        </Col>
                        
                        <Col lg={12} className="justify-content-center">
      
                            <ProfileTab contactos ={contacto} />
                           
                        </Col>
                    </Row>
                )}
                </Container>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = (state) => {
    const { error, loading, contacts,contactsUpdated } = state.Contacts;
    return { error, loading, contacts ,contactsUpdated};
  };
  

  ContactProfile.propTypes = {
    error: PropTypes.any,
    loading: PropTypes.bool,
    contactsUpdated: PropTypes.object,
  };
  export default withRouter(connect(mapStateToProps)(ContactProfile));